
import page from "~/layouts/testimonial.vue";

export default {
  components: {
    page,
  },

  data() {
    return {
      itemsAdvantage: [
        {
          principal: "Une identité visuelle épatante :",
          description:
            "Avec des cartes de visite qui en feront succomber plus d’un. ",
        },
        {
          principal: "Un profil Facebook qui cartonne : ",
          description:
            "Réseau indispensable pour les professionnels qui souhaitent booster leur visibilité.",
        },
        {
          principal: "Un site internet attractif :",
          description: "Outil essentiel pour partir comme une fusée.",
        },
        {
          principal: "Un référencement impactant :",
          description:
            "Rien de mieux pour une visibilité et une attractivité sur Google.",
        },
      ],
    };
  },

  head() {
    return {
      title: "Création de site internet pour Couvreur-Zingueur | Agence ALEO",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Pour se démarquer dans le secteur du bâtiment, nous avons imaginé une stratégie de communication adaptée au budget ce client expert de la rénovation !",
        },
        // {
        //   hid: "og:image",
        //   property: "og:image",
        //   content: require("~/assets/img/blog/thumbnail-header-21.jpeg"),
        // },
      ],
    };
  },
};
